import React, { Component } from 'react';
import PaymentList from './PaymentList';
import PaymentSave from './PaymentSave';
import WithRouter from 'custom/withRouter';

class PaymentPage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const p = this.props;
        const paymentId = p.params.id;
        const isSave = paymentId || p.location.pathname === "/manage/payment/add";
        return (
            <React.Fragment>
                {isSave
                        ?
                        <PaymentSave
                            name="paymentSave"
                            params={p.params}
                            title="Payment Info" />
                        :
                        <PaymentList title="List of Payments" />
                }
            </React.Fragment>
        );
    }
}

export default WithRouter(PaymentPage);